import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { map, take } from 'rxjs';
import { JwtRefreshService } from '../../../global-services/jwt-refresh.service';
import { UserService } from '../../../global-services/user.service';
import { SidenavService } from '../sidenav.service';

@Component({
  selector: 'ss-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.css'],
  host: {
    class: 'flex-column gap-none'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent {

  readonly userSubject = this._userService.userSubject

  readonly displayObs = this.userSubject.pipe(
    map((user) => [user.firstName, user.lastName].join(' '))
  )

  readonly initialsObs = this.userSubject.pipe(
    map((user) => [user.firstName.charAt(0).toUpperCase(), user.lastName.charAt(0).toUpperCase()].join(''))
  )

  readonly emailObs = this.userSubject.pipe(
    map(user => user.email)
  )

  readonly userMenuOpenedSubject = this._sidenavService.userMenuOpenedSubject

  constructor(
    private readonly _userService: UserService,
    private readonly _jwtRefreshService: JwtRefreshService,
    private readonly _sidenavService: SidenavService,
    private readonly _router: Router

  ) {



  }

  goToUserSettings() {
    this._userService.goToUserSettings()
  }

  logout() {
    this._jwtRefreshService.logout()
      .pipe(take(1))
      .subscribe(() => {
        this._router.navigate(['auth']);
      });
  }
}
